//@ts-ignore
import { LevelSelector3 } from 'mapbox-ui-components';
import React, { useEffect } from 'react';
import './GeoJsonLevel.css';
import { set } from 'rsuite/esm/utils/dateUtils';
interface Props {
  floorDetails: any;
  changeLevel: (level: any) => void;
  floorPlanGeometry: any;
}

export default function LevelSelectorGeoJson({ floorDetails, changeLevel, floorPlanGeometry }: Props) {
  useEffect(() => {
    const holderProxy = document.getElementsByClassName('level-selector-holder')[0];
    if (holderProxy) {
      const antIcon: HTMLElement = holderProxy.getElementsByClassName('anticon anticon-down')[0] as HTMLElement;
      if (antIcon) {
        antIcon.click();
      }
    }
  }, []);
  console.log(floorPlanGeometry, 'floorPlanGeometry for figma');

  const onLevelSelect = (level: any) => {
    // console.log(level, 'level for figma');
    changeLevel(level);
  };

  return (
    <div className="level-selector-holder">
      <LevelSelector3
        marginHorizontal={0}
        marginVertical={0}
        height={500}
        // width={'380px'}
        placement="top-left"
        levels={floorPlanGeometry ?? []} // array of geojson feature
        onLevelSelect={onLevelSelect} // callback
        activeLevelId={floorDetails?.floor_number.toString()} // currently selected level (can be null)
        defaultSpacing={0}
      />
    </div>
  );
}
